import * as React from "react";
// import "./style.css";

export interface IFilterRadioButtonProps {
    title: string;
    tag: number;
    checked: boolean;
    onClick: (e: any, tag: number) => void;
}

const FilterRadioButton: React.StatelessComponent<IFilterRadioButtonProps> = props => {
    const klass = props.checked ? "btn btn-default svg-image-button btn-sidebar-filter active" : "btn btn-default svg-image-button btn-sidebar-filter"
    return (
        <button className={klass} onClick={(e) => props.onClick(e, props.tag)}>
            {props.children}
            <span>{props.title}</span>
        </button>
    );
}

export default FilterRadioButton;



// WEBPACK FOOTER //
// ./src/components/report-sidebar-filters/filter-button.tsx